import Quadrant from './Quadrant';
import ParameterErrors from '../../../errors/ParameterErrors';
const { throwNotProvided } = ParameterErrors;
const X_Y_Z_QUADRANT_JSON_KEY='q2';
export default class QuadrantLevel{
	constructor({x_Y_Z_Quadrant}){
		this._X_Y_Z_Quadrant = x_Y_Z_Quadrant; 
	}
	getObjectIds({proportionX, proportionY, proportionZ}){
		const xIndex = parseInt(proportionX/this._X_Y_Z_Quadrant.length);
		const y_Z_Quadrant = this._X_Y_Z_Quadrant[xIndex];
		if(y_Z_Quadrant===null||y_Z_Quadrant===undefined||y_Z_Quadrant.length<1)return null;
		const yIndex = parseInt(proportionY/y_Z_Quadrant.length);
		const z_Quadrant = y_Z_Quadrant[yIndex];
		if(z_Quadrant===null||z_Quadrant===undefined||z_Quadrant.length<1) return null;
		const zIndex = parseInt(proportionZ/z_Quadrant.length);
		const quadrant = z_Quadrant[zIndex];
		return quadrant.objectIds;
	}
	static fromJSON(jObject){
		const x_Y_Z_Quadrant = jObject[X_Y_Z_QUADRANT_JSON_KEY]
			.map(y_Z_Quadrant=>
				y_Z_Quadrant
				.map(z_Quadrant=>
					z_Quadrant
					.map(quadrant=>
						Quadrant.fromJSON(quadrant)
				)
			)
		);
		return new QuadrantLevel({x_Y_Z_Quadrant});
	}
}